import { TFunction } from 'i18next';

export const formatFloorNumber = (floor: number, language: string, t: TFunction) => {
    if (floor === 0) {
        return t('room_card_ground_floor');
    }

    if (language === 'es') {
        // In Spanish "1st/2nd floor" is written as "1a/2a planta" with "a" as a sup text
        return `${floor}<span>&#170;</span> ${t('room_card_floor')}`;
    }
    return `${t('room_card_floor')} ${floor}`;
};
